import { render, staticRenderFns } from "./CommunityProjects.vue?vue&type=template&id=61c8c3bd&"
import script from "./CommunityProjects.vue?vue&type=script&lang=js&"
export * from "./CommunityProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports